<template>
  <div id="HomePage">
    <div class="video-mark" @mousewheel = "mouseWheel" >
      <div class="show-upper-video">
        <img src="../assets/img/logo_mingshuo.png" alt="" class="video-logo">
        <div class="flex-center video-upper-box">
          <div class="company-name">四川明槊科技有限公司</div>
          <div style="text-align: center">车位增值运营<br>城市级智慧停车整体解决方案提供商</div>
          <div class="company-button" @click="toHomePage">查看更多&gt;</div>
        </div>
      </div>
      <video id="startVideo" src="https://shareimage.foxshare.city/homepage-assets/video/1%E5%88%86%E9%92%9F%E5%AE%A3%E4%BC%A0%E8%A7%86%E9%A2%91.mp4" muted="muted" autoplay="autoplay" preload="auto" controls="controls" loop style="width: 100%; height: 100vh;"></video>
    </div>
  </div>
</template>
<script>
export default {
  name: "Home",
  data() {
    return {
      isShowVidio:true,
    };
  },
  mounted() {
    var videos = document.getElementById("startVideo")
    videos.play();
  },
  methods: {

    toHomePage(){
      this.isShowVidio = false
      console.log( this.$router)

      this.$router.push({path:'/HomePage'})
    },
    mouseWheel (e) {
      if (e.wheelDelta || e.detail) {
        // if (e.wheelDelta > 0 || e.detail < 0) {     //当鼠标滚轮向上滚动时
        //   console.log("向上")
        // }
        if (e.wheelDelta < 0 || e.detail > 0) {     //当鼠标滚轮向下滚动时
          this.isShowVidio = false
          if(e.preventDefault){
            e.preventDefault()
            this.$router.push('/HomePage')
          }
        }
      }
    },
  }
};
</script>
<style scoped >
/* 整体盒子 */
#HomePage {
  width: 100%;
}
video {
  object-fit: fill;
}
.video-mark {
  position: relative;
  z-index:99999;
  background: #000000;
}

.video-mark .show-upper-video {
  content: " ";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,.5);
  color: #fff;
  z-index: 999999;
}

.video-mark .show-upper-video .video-logo {
  width: 12%;
  margin: 15px 0 0 20px;
}

.video-mark .show-upper-video .video-upper-box {
  flex-direction: column;
  font-size: 1.2em;
  font-weight: 400;
  height: 100vh;
  display: flex;
  /*justify-content: center;*/
  /*align-items: center;*/
  z-index: 11;
  /*text-align: center;*/
}

.video-mark .show-upper-video .video-upper-box .company-name {
  font-size: 3em;
  margin-bottom: 15px
}

.video-mark .show-upper-video .video-upper-box .company-name {
  font-size: 3em;
  margin-bottom: 15px
}

.video-mark .show-upper-video .video-upper-box .company-button {
  background: #c45021;
  font-size: 1em;
  text-align: center;
  padding: 10px 15px;
  border-radius: 3px;
  margin-top: 25px;
  cursor: pointer
}


/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  video {
    object-fit: contain;
  }
  .video-mark .show-upper-video .video-logo {
    display: none;
  }
  .video-mark .show-upper-video .video-upper-box .company-name {
    font-size: 1.5em;
  }


}

/* 媒体查询（平板） */
@media screen and (min-width: 768px) and (max-width: 996px) {

  video {
    object-fit: contain;
  }
  .video-mark .show-upper-video .video-logo {
    display: none;
  }
  .video-mark .show-upper-video .video-upper-box .company-name {
    font-size: 1.5em;
  }


}
</style>




// WEBPACK FOOTER //
// src/view/Home.vue